// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { GRRulesBackgroundImgPath } from '../assets/img/rules';
import { getGRRulesByRound } from '../constants/labels';
import { type GRRound } from '../types/round';

import GRRule from './common/GRRule';
import GRViewWrapper from './common/GRViewWrapper';

const StyledGRViewWrapper = styled(GRViewWrapper)`
  padding: 0;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;

    background: inherit;
    filter: blur(4px);
  }

  background-image: url(${GRRulesBackgroundImgPath});
`;

const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;

  align-items: center;
  justify-content: center;
  padding: 1em;
`;

type GRRoundRulesProps = {
  className?: string;
  roundId: GRRound;
  openExternalLink: (url: string, options?: unknown) => void;
  maxPoints: number;
  minStakeMultiplicator: number;
  maxStakeMultiplicator: number;
};

const GRRoundRules = ({
  className,
  roundId,
  maxPoints,
  minStakeMultiplicator,
  maxStakeMultiplicator,
  openExternalLink,
}: GRRoundRulesProps) => {
  const rule = useMemo(
    () => getGRRulesByRound(maxPoints, minStakeMultiplicator, maxStakeMultiplicator)[roundId],
    [maxPoints, minStakeMultiplicator, maxStakeMultiplicator, roundId],
  );

  return rule ? (
    <StyledGRViewWrapper className={className} viewType={roundId}>
      <InnerWrapper>
        <GRRule {...rule} openExternalLink={openExternalLink} />
      </InnerWrapper>
    </StyledGRViewWrapper>
  ) : null;
};

export default GRRoundRules;
